import { useMemo } from 'react';

import { DataTable } from '@/shared/ui/data-table';

import {
  type TriggerConditions,
  useSignalAlertPreviewTableColumn,
} from '../../hooks';
import type { SignalAlertPreviewIssue } from '../../model';

type SignalAlertPreviewTableProps = {
  data: SignalAlertPreviewIssue[];
  duration: number;
  conditions: TriggerConditions;
  loading?: boolean;
};

export function SignalAlertPreviewTable({
  data,
  duration,
  conditions,
  loading,
}: SignalAlertPreviewTableProps) {
  const { createColumns } = useSignalAlertPreviewTableColumn();
  const columns = useMemo(
    () => createColumns(duration, conditions),
    [createColumns, duration, conditions],
  );

  return (
    <div className="flex h-full min-h-0 flex-col gap-3 w-full">
      <div className="flex flex-col gap-1">
        <p className="text-sm font-semibold">Previewing sampled issues</p>
        <p className="text-muted-foreground text-xs">
          This preview shows the most recent issues. Some changes may only
          appear after saving.
        </p>
      </div>
      <div className="min-h-0 flex-1 overflow-auto rounded-lg bg-white">
        <DataTable
          columns={columns}
          data={data}
          loading={loading}
          headerClassName="sticky top-0 z-10 bg-white"
          className="min-w-max"
          size="sm"
        />
      </div>
    </div>
  );
}
